import React, { useState, useEffect } from "react";
import { Table, Select, InputNumber, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import ModalEvaluationAnswerGroup from "../modalEvaluationAnswerGroup/modalEvaluationAnswerGroup";

const { Option } = Select;

const TableAttributeAnswerGroupRelation = ({
    relEvlCmpEag = [],
    dataEvaluationAnswerGroups = [],
    handleSelectChange,
    handleWeightChange,
    onWeightTotalChange,
    title = "Atributo del líder",
}) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [currentCmpId, setCurrentCmpId] = useState(null);
    const [weightTotal, setWeightTotal] = useState(0);

    useEffect(() => {
        const total = relEvlCmpEag.reduce(
            (acc, item) => acc + (parseFloat(item.weight) || 0),
            0
        );
        setWeightTotal(total.toFixed(1));
        onWeightTotalChange(total, total === 100);
    }, [relEvlCmpEag, onWeightTotalChange]);

    const openModal = (cmpId) => {
        setCurrentCmpId(cmpId);
        setModalVisible(true);
    };

    const handleCardSelect = (eagId) => {
        if (currentCmpId) {
            handleSelectChange(currentCmpId, eagId);
            setModalVisible(false);
        }
    };

    const columns = [
        {
            title,
            dataIndex: "name",
        },
        {
            title: "Descripción",
            dataIndex: "description",
        },
        {
            title: (
                <>
                    Grupo de Respuesta{" "}
                    <Tooltip title="Haga clic en el ícono para ver más detalles">
                        <InfoCircleOutlined style={{ cursor: "pointer" }} />
                    </Tooltip>
                </>
            ),
            render: (_, record) => (
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                    <Select
                        placeholder="Seleccione grupo"
                        value={record.eag_id}
                        dropdownMatchSelectWidth={false}
                        style={{ minWidth: 200, width: "auto", maxWidth: 300 }}
                        onChange={(value) => handleSelectChange(record.cmp_id, value)}
                    >
                        {dataEvaluationAnswerGroups.map((eag) => (
                            <Option key={eag.eag_id} value={eag.eag_id}>
                                {eag.eag_title}
                            </Option>
                        ))}
                    </Select>
                    <Tooltip title="Ver opciones de respuesta">
                        <InfoCircleOutlined
                            style={{ cursor: "pointer", color: "#1890ff" }}
                            onClick={() => openModal(record.cmp_id)}
                        />
                    </Tooltip>
                </div>
            ),
        },
        {
            title: (
                <>
                    Peso{" "}
                    <Tooltip title="Asignar peso entre 0 y 100. Se usa para ponderar la competencia.">
                        <InfoCircleOutlined />
                    </Tooltip>
                </>
            ),
            render: (_, record) => (
                <InputNumber
                    min={0}
                    max={100}
                    step={0.1}
                    value={record.weight}
                    onChange={(value) => handleWeightChange(record.cmp_id, value)}
                />
            ),
        },
    ];

    return (
        <>
            <Table
                className="custom-green-table"
                size="small"
                dataSource={relEvlCmpEag}
                columns={columns}
                rowKey="id"
                pagination={false}
                footer={() => (
                    <div
                        style={{
                            textAlign: "right",
                            fontWeight: "bold",
                            color: weightTotal === "100.0" ? "green" : "red",
                        }}
                    >
                        Total: {weightTotal}%
                    </div>
                )}
            />

            <ModalEvaluationAnswerGroup
                visible={modalVisible}
                onClose={() => setModalVisible(false)}
                onSelect={handleCardSelect}
                dataEvaluationAnswerGroups={dataEvaluationAnswerGroups}
            />
        </>
    );
};

export default TableAttributeAnswerGroupRelation;
